// extracted by mini-css-extract-plugin
export default {"Message":"Message_Message__QrbRe","Confirmation":"Message_Confirmation__VNqrD","Controls":"Message_Controls__m7OQr","Control":"Message_Control__Ovpmb","em":"Message_em__3PSV8"};